import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Setting } from '@easy-lib/modules/settings';
export const SettingAction = createActionGroup({
	source: 'Setting',
	events: {
		load: emptyProps(),
		set: props<{ setting: Setting }>(),
		update: props<{ setting: Setting }>(),
		reset: emptyProps(),
		resetDone: emptyProps(),
		updated: emptyProps(),
		none: emptyProps()
	}
});
